
import React from 'react';
import { Calendar, Droplet, Flower, Cloud, Thermometer, Sun, Wrench, FileSpreadsheet } from 'lucide-react';
import { cn } from '@/lib/utils';

type ActivityTypeIconProps = {
  type: string;
  className?: string;
  size?: number;
};

export const ActivityTypeIcon: React.FC<ActivityTypeIconProps> = ({ 
  type,
  className,
  size = 16
}) => {
  const getIconByType = () => {
    switch (type) {
      case 'irrigation':
        return <Droplet size={size} className="text-blue-500" />;
      case 'fertilization':
        return <Flower size={size} className="text-green-500" />;
      case 'weather':
        return <Cloud size={size} className="text-gray-500" />;
      case 'harvest':
        return <Sun size={size} className="text-yellow-500" />;
      case 'planting':
        return <Flower size={size} className="text-farm-gold" />;
      case 'maintenance':
        return <Wrench size={size} className="text-gray-600" />;
      case 'inspection':
        return <FileSpreadsheet size={size} className="text-blue-600" />;
      default:
        return <Calendar size={size} className="text-primary" />;
    }
  };

  return (
    <div className={cn('flex items-center justify-center', className)}>
      {getIconByType()}
    </div>
  );
};
